import { Caption, CardBox, CardHeader, CardTitle } from './styles';

import styled from '@/styles';

const Grid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '16px',
  padding: '16px 20px',
});

const Label = styled('div', { fontWeight: 600, marginBottom: '4px' });

const FIXED_RULES = [
  {
    title: 'Frequency',
    text: 'At most 1 journey message per day, 4 per week, 3 SMS per week.',
  },
  {
    title: "Quiet hours (worker's local time)",
    // The hours nothing goes, as the Overview card says (review D-12).
    text: 'No SMS 8 PM to 8 AM. No push 9 PM to 8 AM. Email any time.',
  },
  {
    title: 'Channel order',
    // Mirrors SendDecision#choose_channel: only channels the step has copy
    // for, and no switch for multi-channel or push-only sends (review J-06).
    text: 'Each step uses its own channel. If that is not allowed, it uses the next of SMS, push and email that the step has copy for. Messages sent on several channels, and push-only ones, never switch.',
  },
  {
    title: 'Measurement',
    text: "Holdout per journey (in each row). Goal = the journey's exit rule. SMS pauses by itself when the STOP rate is over 2% with 50+ SMS in 7 days.",
  },
];

const GuardrailsCard = () => (
  <CardBox aria-labelledby="grTitle" data-testid="guardrailsCard">
    <CardHeader css={{ borderBottom: 'none', paddingBottom: 0 }}>
      <CardTitle id="grTitle">Guardrails and measurement</CardTitle>
      <Caption>Fixed in code. Not editable here.</Caption>
    </CardHeader>
    <Grid>
      {FIXED_RULES.map((rule) => (
        <div key={rule.title}>
          <Label>{rule.title}</Label>
          <div>{rule.text}</div>
        </div>
      ))}
    </Grid>
  </CardBox>
);

export default GuardrailsCard;
